import { LatestCreditsHistoryResponse, LatestCreditsHistoryTableData } from './interfaces';

export const mapApiDataIntoTableFormat = (data: LatestCreditsHistoryResponse[]): LatestCreditsHistoryTableData[] =>
  data.map((current: LatestCreditsHistoryResponse) => ({ ...current, cost: current.cost.value }));
